<div class="page" [class.display]="!groupColumns || groupColumns.length == 0" *ngIf="isShowModal">
  <div class="box" *ngFor="let Column of groupColumns">
    <div class="gapcol hiddengap" *ngIf="!Column.value"></div>
    <ng-container *ngFor="let formControlModel of Column.value">
      <div
        class="coll"
        *ngIf="formControlModel?.isFloat === 3 || formControlModel?.isFloat === 2"
        [class.emptyrow]="formControlModel?.isFloat === 3 || formControlModel?.isFloat === 2"></div>
      <div
        class="coll"
        [class.IsFloat]="formControlModel?.isFloat === 1 || formControlModel?.isFloat === 2"
        [class.custom-class]="formControlModel?.isFloat === 5">
        <div [ngSwitch]="formControlModel?.controlType">
          <div *ngSwitchCase="FormControlTypes.textbox">
            <ssg-input
              [defaultHeight]="defaultHeight"
              [group]="group"
              [isGetPath]="formControlModel?.isGetPath"
              [accept]="formControlModel?.accept"
              id="txt{{ formControlModel?.name }}"
              [name]="formControlModel?.name"
              [label]="formControlModel?.label"
              [isDecimal]="formControlModel?.isDecimal"
              [isNumberOnly]="formControlModel?.isNumberOnly"
              [isNullable]="formControlModel?.isNullable"
              [required]="formControlModel?.required"
              [textType]="formControlModel?.textType"
              [minLength]="formControlModel?.minLength"
              [maxLength]="formControlModel?.maxLength"
              [min]="formControlModel?.min"
              [max]="formControlModel?.max"
              [disabled]="formControlModel?.disabled"
              [patternKey]="formControlModel?.patternKey"
              [inputMask]="formControlModel?.inputMask"
              [withComma]="formControlModel?.withComma"
              [tabOrder]="formControlModel?.tabOrder"
              [userClass]="formControlModel?.userClass"
              (valueChange)="change($event)"
              (valueChangeWithName)="valueChangeWithName.emit($event)"
              [inputMode]="formControlModel?.inputMode">
            </ssg-input>
          </div>
          <div *ngSwitchCase="FormControlTypes.datePicker">
            <date-picker
              id="dp{{ formControlModel?.name }}"
              [defaultHeight]="defaultHeight"
              [group]="group"
              name="{{ formControlModel?.name }}"
              label="{{ formControlModel?.label }}"
              [required]="formControlModel?.required"
              textType="{{ formControlModel?.textType }}"
              [disabled]="formControlModel?.disabled"
              [tabOrder]="formControlModel?.tabOrder"
              [userClass]="formControlModel?.userClass"
              (valueChange)="change($event)"
              (valueChangeWithName)="valueChangeWithName.emit($event)">
            </date-picker>
          </div>
          <div *ngSwitchCase="FormControlTypes.Button">
            <ssg-button
              [icon]="formControlModel.buttonIcon"
              [userClass]="formControlModel?.userClass"
              label="{{ formControlModel?.label }}"
              [disabled]="formControlModel?.disabled"
              (click)="change(formControlModel?.name)">
            </ssg-button>
          </div>
          <div *ngSwitchCase="FormControlTypes.checkbox">
            <ssg-checkbox
              id="checkbox{{ formControlModel?.name }}"
              [group]="group"
              name="{{ formControlModel?.name }}"
              label="{{ formControlModel?.label }}"
              [required]="formControlModel?.required"
              [defaultHeight]="defaultHeight"
              [disabled]="formControlModel?.disabled"
              [tabOrder]="formControlModel?.tabOrder"
              (valueChange)="change($event)"
              [userClass]="formControlModel?.userClass"
              (valueChangeWithName)="valueChangeWithName.emit($event)">
            </ssg-checkbox>
          </div>
          <div *ngSwitchCase="FormControlTypes.textboxMultiline">
            <ssg-textarea
              id="textarea{{ formControlModel?.name }}"
              name="{{ formControlModel?.name }}"
              [group]="group"
              label="{{ formControlModel?.label }}"
              [required]="formControlModel?.required"
              [defaultHeight]="defaultHeight"
              textType="{{ formControlModel?.textType }}"
              [minLength]="formControlModel?.minLength"
              [maxLength]="formControlModel?.maxLength"
              [disabled]="formControlModel?.disabled"
              [userClass]="formControlModel?.userClass"
              [tabOrder]="formControlModel?.tabOrder"
              (valueChange)="change($event)">
            </ssg-textarea>
          </div>
          <div *ngSwitchCase="FormControlTypes.dropdown">
            <ssg-select
              name="{{ formControlModel?.name }}"
              [defaultHeight]="defaultHeight"
              id="select{{ formControlModel?.name }}"
              [group]="group"
              label="{{ formControlModel?.label }}"
              apiName="{{ formControlModel?.apiName }}"
              systemName="{{ formControlModel?.systemName }}"
              category="{{ formControlModel?.category }}"
              textFieldName="{{ formControlModel?.displayMember }}"
              valueFieldName="{{ formControlModel?.valueMember }}"
              [textFieldName]="formControlModel?.name === 'ItemAdjustmentKindId' ? 'label' : formControlModel?.displayMember"
              [valueFieldName]="formControlModel?.name === 'ItemAdjustmentKindId' ? 'value' : formControlModel?.valueMember"
              [disabled]="formControlModel?.disabled"
              (valueChangeByApiName)="valueChangeByApiName.emit($event)"
              [hasDefault]="hasDefault"
              [required]="formControlModel?.required"
              (valueChange)="change($event)"
              [dataList]="formControlModel?.dataList"
              [paretnIdValue]="model[formControlModel?.parentIdName]"
              [parentIdName]="formControlModel?.parentIdName"
              [filterValue]="model[formControlModel?.filterKey]"
              [userClass]="formControlModel?.userClass"
              [tabOrder]="formControlModel?.tabOrder"
              (CompleteData)="CompleteData.emit($event)"
              [multiple]="formControlModel?.IsMultiSelect"
              [filterKey]="formControlModel?.filterKey"
              [SortColumn]="formControlModel?.SortColumn"
              [IsEqual]="formControlModel?.IsEqual"
              appendTo="body">
            </ssg-select>
          </div>
          <div *ngSwitchCase="FormControlTypes.radioList" class="radio {{ formControlModel?.userClass }}">
            <ssg-radiobox
              name="{{ formControlModel?.name }}"
              id="radiobox{{ formControlModel?.name }}"
              [group]="group"
              label="{{ formControlModel?.label }}"
              apiName="{{ formControlModel?.apiName }}"
              systemName="{{ formControlModel?.systemName }}"
              category="{{ formControlModel?.category }}"
              textFieldName="{{ formControlModel?.displayMember }}"
              valueFieldName="{{ formControlModel?.valueMember }}"
              [required]="formControlModel?.required"
              [disabled]="formControlModel?.disabled"
              [userClass]="formControlModel?.userClass"
              [defaultHeight]="defaultHeight"
              [tabOrder]="formControlModel?.tabOrder"
              (valueChange)="change($event)"
              (CompleteData)="CompleteData.emit($event)"
              (valueChangeWithName)="valueChangeWithName.emit($event)">
            </ssg-radiobox>
          </div>
          <div *ngSwitchCase="FormControlTypes.colorPicker">
            <sepidz-color-picker
              name="{{ formControlModel?.name }}"
              id="radiobox{{ formControlModel?.name }}"
              [group]="group"
              label="{{ formControlModel?.label }}"
              [userClass]="formControlModel?.userClass"
              [disabled]="formControlModel?.disabled"
              [tabOrder]="formControlModel?.tabOrder"
              (valueChange)="change($event)"
              [defaultHeight]="defaultHeight">
            </sepidz-color-picker>
          </div>
          <div *ngSwitchCase="FormControlTypes.lookup">
            <st-lookup
              name="{{ formControlModel?.name }}"
              [defaultHeight]="defaultHeight"
              id="lookup{{ formControlModel?.name }}"
              [group]="group"
              isModalParent="{{ isShowModal }}"
              label="{{ formControlModel?.label }}"
              apiName="{{ formControlModel?.apiName }}"
              systemName="{{ formControlModel?.systemName }}"
              category="{{ formControlModel?.category }}"
              textFieldName="{{ formControlModel?.displayMember }}"
              textColumnsName="{{ formControlModel?.columnsName }}"
              valueFieldName="{{ formControlModel?.valueMember }}"
              [disabled]="formControlModel?.disabled"
              (valueChangeByApiName)="valueChangeByApiName.emit($event)"
              (valueChange)="change($event)"
              [filterLookUp]="filterLookUp"
              [userClass]="formControlModel?.userClass"
              (onRowSelected)="onRowSelected.emit($event)"
              (onRowsSelected)="onRowsSelected.emit($event)"
              (CompleteData)="CompleteData.emit($event)"
              [defaultSortKey]="formControlModel?.defaultSortKey"
              [defaultSortKeyKind]="formControlModel?.defaultSortKeyKind"
              [tabOrder]="formControlModel?.tabOrder"
              [required]="formControlModel?.required">
            </st-lookup>
          </div>
          <div *ngSwitchCase="FormControlTypes.multiColumnsSelector">
            <ssg-select
              name="{{ formControlModel?.name }}"
              [multiple]="formControlModel?.isMultiSelectAttribute"
              [defaultHeight]="defaultHeight"
              id="select{{ formControlModel?.name }}"
              [group]="group"
              label="{{ formControlModel?.label }}"
              apiName="{{ formControlModel?.apiName }}"
              systemName="{{ formControlModel?.systemName }}"
              category="{{ formControlModel?.category }}"
              textFieldName="{{ formControlModel?.displayMember }}"
              valueFieldName="{{ formControlModel?.valueMember }}"
              [disabled]="formControlModel?.disabled"
              (valueChangeByApiName)="valueChangeByApiName.emit($event)"
              [hasDefault]="hasDefault"
              [required]="formControlModel?.required"
              (valueChange)="change($event)"
              [dataList]="formControlModel?.dataList"
              [paretnIdValue]="model[formControlModel?.parentIdName]"
              [parentIdName]="formControlModel?.parentIdName"
              [filterValue]="model[formControlModel?.filterKey]"
              [userClass]="formControlModel?.userClass"
              [tabOrder]="formControlModel?.tabOrder"
              (CompleteData)="CompleteData.emit($event)"
              isMultiColumns="true"
              textColumnsName="{{ formControlModel?.columnsName }}"
              valueFieldName="{{ formControlModel?.valueMember }}"
              [filterKey]="formControlModel?.filterKey"
              [SortColumn]="formControlModel?.SortColumn"
              [IsEqual]="formControlModel?.IsEqual"
              [columnsTitleName]="formControlModel?.columnsTitleName"
              appendTo="body">
            </ssg-select>
          </div>
          <div *ngSwitchCase="FormControlTypes.treelookup">
            <tree-lookup
              name="{{ formControlModel?.name }}"
              [group]="group"
              [hasCheckBoxLookUpTree]="hasCheckBoxLookUpTree"
              [defaultHeight]="defaultHeight"
              id="treelookup{{ formControlModel?.name }}"
              label="{{ formControlModel?.label }}"
              apiName="{{ formControlModel?.apiName }}"
              systemName="{{ formControlModel?.systemName }}"
              category="{{ formControlModel?.category }}"
              textFieldName="{{ formControlModel?.displayMember }}"
              textColumnsName="{{ formControlModel?.columnsName }}"
              valueFieldName="{{ formControlModel?.valueMember }}"
              (valueChangeByApiName)="valueChangeByApiName.emit($event)"
              (onRowSelected)="onRowSelected.emit($event)"
              [disabled]="formControlModel?.disabled"
              [parentIdName]="formControlModel?.parentIdName"
              [userClass]="formControlModel?.userClass"
              (valueChange)="change($event)"
              [tabOrder]="formControlModel?.tabOrder"
              [filterKey]="formControlModel?.filterKey"
              [required]="formControlModel?.required">
            </tree-lookup>
          </div>
        </div>
      </div>
      <div class="coll" *ngIf="formControlModel?.isFloat === 4" [class.emptyrow]="formControlModel?.isFloat === 4"></div>
    </ng-container>
  </div>
  <ng-content select=".fc-Content"></ng-content>
</div>

<div class="form-wrapper" [class.d-none]="!groupColumns || groupColumns.length == 0" *ngIf="!isShowModal">
  <div class="form">
    <ng-container *ngFor="let column of groupColumns; let i = index">
      <div class="form-box" *ngIf="column.value" [ngClass]="'form-column-' + (i + 1)">
        <ng-container *ngFor="let formControlModel of column.value">
          <ng-container [ngSwitch]="formControlModel?.controlType">
            <div class="form-item {{ formControlModel?.userClass }}" *ngSwitchCase="FormControlTypes.textbox">
              <!-- <ng-container *ngIf="formControlModel?.disabled; else textboxTemplate">
                <div class="text-model">
                  <span> {{ formControlModel?.label }} : </span>
                  {{ group[formControlModel?.name]?.value ?? "--" }}
                </div>
              </ng-container>
              <ng-template #textboxTemplate> -->
              <ssg-input
                [defaultHeight]="defaultHeight"
                [group]="group"
                [isGetPath]="formControlModel?.isGetPath"
                [accept]="formControlModel?.accept"
                id="txt{{ formControlModel?.name }}"
                [name]="formControlModel?.name"
                [label]="formControlModel?.label"
                [isDecimal]="formControlModel?.isDecimal"
                [isNumberOnly]="formControlModel?.isNumberOnly"
                [isNullable]="formControlModel?.isNullable"
                [required]="formControlModel?.required"
                [textType]="formControlModel?.textType"
                [minLength]="formControlModel?.minLength"
                [maxLength]="formControlModel?.maxLength"
                [min]="formControlModel?.min"
                [max]="formControlModel?.max"
                [disabled]="formControlModel?.disabled"
                [patternKey]="formControlModel?.patternKey"
                [inputMask]="formControlModel?.inputMask"
                [withComma]="formControlModel?.withComma"
                [tabOrder]="formControlModel?.tabOrder"
                (valueChange)="change($event)"
                (valueChangeWithName)="valueChangeWithName.emit($event)"
                [inputMode]="formControlModel?.inputMode">
              </ssg-input>
              <!-- </ng-template> -->
            </div>
            <div class="form-item {{ formControlModel?.userClass }}" *ngSwitchCase="FormControlTypes.datePicker">
              <date-picker
                id="dp{{ formControlModel?.name }}"
                [defaultHeight]="defaultHeight"
                [group]="group"
                name="{{ formControlModel?.name }}"
                label="{{ formControlModel?.label }}"
                [required]="formControlModel?.required"
                textType="{{ formControlModel?.textType }}"
                [disabled]="formControlModel?.disabled"
                [tabOrder]="formControlModel?.tabOrder"
                (valueChange)="change($event)"
                (valueChangeWithName)="valueChangeWithName.emit($event)">
              </date-picker>
            </div>
            <div class="form-item {{ formControlModel?.userClass }}" *ngSwitchCase="FormControlTypes.Button">
              <ssg-button
                [icon]="formControlModel.buttonIcon"
                label="{{ formControlModel?.label }}"
                [disabled]="formControlModel?.disabled"
                (click)="change(formControlModel?.name)">
              </ssg-button>
            </div>
            <div class="form-item {{ formControlModel?.userClass }}" *ngSwitchCase="FormControlTypes.checkbox">
              <ssg-checkbox
                id="checkbox{{ formControlModel?.name }}"
                [group]="group"
                name="{{ formControlModel?.name }}"
                label="{{ formControlModel?.label }}"
                [required]="formControlModel?.required"
                [defaultHeight]="defaultHeight"
                [disabled]="formControlModel?.disabled"
                [tabOrder]="formControlModel?.tabOrder"
                (valueChange)="change($event)"
                (valueChangeWithName)="valueChangeWithName.emit($event)">
              </ssg-checkbox>
            </div>
            <div class="form-item {{ formControlModel?.userClass }}" *ngSwitchCase="FormControlTypes.textboxMultiline">
              <ssg-textarea
                id="textarea{{ formControlModel?.name }}"
                name="{{ formControlModel?.name }}"
                [group]="group"
                label="{{ formControlModel?.label }}"
                [required]="formControlModel?.required"
                [defaultHeight]="defaultHeight"
                textType="{{ formControlModel?.textType }}"
                [minLength]="formControlModel?.minLength"
                [maxLength]="formControlModel?.maxLength"
                [disabled]="formControlModel?.disabled"
                [tabOrder]="formControlModel?.tabOrder"
                (valueChange)="change($event)">
              </ssg-textarea>
            </div>
            <div class="form-item {{ formControlModel?.userClass }}" *ngSwitchCase="FormControlTypes.dropdown">
              <ssg-select
                name="{{ formControlModel?.name }}"
                [defaultHeight]="defaultHeight"
                id="select{{ formControlModel?.name }}"
                [group]="group"
                label="{{ formControlModel?.label }}"
                apiName="{{ formControlModel?.apiName }}"
                systemName="{{ formControlModel?.systemName }}"
                category="{{ formControlModel?.category }}"
                textFieldName="{{ formControlModel?.displayMember }}"
                valueFieldName="{{ formControlModel?.valueMember }}"
                [disabled]="formControlModel?.disabled"
                (valueChangeByApiName)="valueChangeByApiName.emit($event)"
                [hasDefault]="hasDefault"
                [required]="formControlModel?.required"
                (valueChange)="change($event)"
                [dataList]="formControlModel?.dataList"
                [paretnIdValue]="model[formControlModel?.parentIdName]"
                [parentIdName]="formControlModel?.parentIdName"
                [filterValue]="model[formControlModel?.filterKey]"
                [tabOrder]="formControlModel?.tabOrder"
                (CompleteData)="CompleteData.emit($event)"
                [multiple]="formControlModel?.IsMultiSelect"
                [filterKey]="formControlModel?.filterKey"
                [SortColumn]="formControlModel?.SortColumn"
                [IsEqual]="formControlModel?.IsEqual"
                appendTo="body">
              </ssg-select>
            </div>
            <div class="form-item {{ formControlModel?.userClass }}" *ngSwitchCase="FormControlTypes.radioList">
              <ssg-radiobox
                name="{{ formControlModel?.name }}"
                id="radiobox{{ formControlModel?.name }}"
                [group]="group"
                label="{{ formControlModel?.label }}"
                apiName="{{ formControlModel?.apiName }}"
                systemName="{{ formControlModel?.systemName }}"
                category="{{ formControlModel?.category }}"
                textFieldName="{{ formControlModel?.displayMember }}"
                valueFieldName="{{ formControlModel?.valueMember }}"
                [required]="formControlModel?.required"
                [disabled]="formControlModel?.disabled"
                [defaultHeight]="defaultHeight"
                [tabOrder]="formControlModel?.tabOrder"
                (valueChange)="change($event)"
                (CompleteData)="CompleteData.emit($event)"
                (valueChangeWithName)="valueChangeWithName.emit($event)">
              </ssg-radiobox>
            </div>
            <div class="form-item {{ formControlModel?.userClass }}" *ngSwitchCase="FormControlTypes.colorPicker">
              <sepidz-color-picker
                name="{{ formControlModel?.name }}"
                id="radiobox{{ formControlModel?.name }}"
                [group]="group"
                label="{{ formControlModel?.label }}"
                [disabled]="formControlModel?.disabled"
                [tabOrder]="formControlModel?.tabOrder"
                (valueChange)="change($event)"
                [defaultHeight]="defaultHeight">
              </sepidz-color-picker>
            </div>
            <div class="form-item {{ formControlModel?.userClass }}" *ngSwitchCase="FormControlTypes.lookup">
              <st-lookup
                name="{{ formControlModel?.name }}"
                [defaultHeight]="defaultHeight"
                id="lookup{{ formControlModel?.name }}"
                [group]="group"
                isModalParent="{{ isShowModal }}"
                label="{{ formControlModel?.label }}"
                apiName="{{ formControlModel?.apiName }}"
                systemName="{{ formControlModel?.systemName }}"
                category="{{ formControlModel?.category }}"
                textFieldName="{{ formControlModel?.displayMember }}"
                textColumnsName="{{ formControlModel?.columnsName }}"
                valueFieldName="{{ formControlModel?.valueMember }}"
                [disabled]="formControlModel?.disabled"
                (valueChangeByApiName)="valueChangeByApiName.emit($event)"
                (valueChange)="change($event)"
                (onRowSelected)="onRowSelected.emit($event)"
                (onRowsSelected)="onRowsSelected.emit($event)"
                [defaultSortKey]="formControlModel?.defaultSortKey"
                [defaultSortKeyKind]="formControlModel?.defaultSortKeyKind"
                [tabOrder]="formControlModel?.tabOrder"
                [required]="formControlModel?.required">
              </st-lookup>
            </div>
            <div class="form-item {{ formControlModel?.userClass }}" *ngSwitchCase="FormControlTypes.multiColumnsSelector">
              <ssg-select
                name="{{ formControlModel?.name }}"
                [multiple]="formControlModel?.isMultiSelectAttribute"
                [defaultHeight]="defaultHeight"
                id="select{{ formControlModel?.name }}"
                [group]="group"
                label="{{ formControlModel?.label }}"
                apiName="{{ formControlModel?.apiName }}"
                systemName="{{ formControlModel?.systemName }}"
                category="{{ formControlModel?.category }}"
                textFieldName="{{ formControlModel?.displayMember }}"
                valueFieldName="{{ formControlModel?.valueMember }}"
                [disabled]="formControlModel?.disabled"
                (valueChangeByApiName)="valueChangeByApiName.emit($event)"
                [hasDefault]="hasDefault"
                [required]="formControlModel?.required"
                (valueChange)="change($event)"
                [dataList]="formControlModel?.dataList"
                [paretnIdValue]="model[formControlModel?.parentIdName]"
                [parentIdName]="formControlModel?.parentIdName"
                [filterValue]="model[formControlModel?.filterKey]"
                [tabOrder]="formControlModel?.tabOrder"
                (CompleteData)="CompleteData.emit($event)"
                isMultiColumns="true"
                textColumnsName="{{ formControlModel?.columnsName }}"
                valueFieldName="{{ formControlModel?.valueMember }}"
                [filterKey]="formControlModel?.filterKey"
                [SortColumn]="formControlModel?.SortColumn"
                [IsEqual]="formControlModel?.IsEqual"
                [columnsTitleName]="formControlModel?.columnsTitleName"
                appendTo="body">
              </ssg-select>
            </div>
            <div class="form-item {{ formControlModel?.userClass }}" *ngSwitchCase="FormControlTypes.treelookup">
              <tree-lookup
                name="{{ formControlModel?.name }}"
                [group]="group"
                [defaultHeight]="defaultHeight"
                id="treelookup{{ formControlModel?.name }}"
                label="{{ formControlModel?.label }}"
                apiName="{{ formControlModel?.apiName }}"
                systemName="{{ formControlModel?.systemName }}"
                category="{{ formControlModel?.category }}"
                textFieldName="{{ formControlModel?.displayMember }}"
                textColumnsName="{{ formControlModel?.columnsName }}"
                valueFieldName="{{ formControlModel?.valueMember }}"
                (valueChangeByApiName)="valueChangeByApiName.emit($event)"
                (onRowSelected)="onRowSelected.emit($event)"
                [disabled]="formControlModel?.disabled"
                [parentIdName]="formControlModel?.parentIdName"
                (valueChange)="change($event)"
                [tabOrder]="formControlModel?.tabOrder"
                [filterKey]="formControlModel?.filterKey"
                [required]="formControlModel?.required">
              </tree-lookup>
            </div>
            <div class="break" *ngIf="formControlModel?.isFloat === 1"></div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="i === groupColumns.length - 1">
          <ng-content select=".fct-Content"></ng-content>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>
